/** Max length of a communication entry. Single source for the schema and the form. */
export const MAX_COMMUNICATION_LENGTH = 4000;

/** DC task type preselected by "Speichern + Aufgabe erstellen", matched by name against the instance catalog. */
export const COMMUNICATION_TASK_TYPE_NAME = 'Kommunikation';

/** Prefix of the generated task title: `Kommunikation <patient name>`. */
export const COMMUNICATION_TASK_TITLE_PREFIX = 'Kommunikation';

/**
 * Shown when the appointment cannot supply the professional or insurance type. The endpoint requires both,
 * so the action is disabled rather than failing after the user has typed an entry.
 */
export const COMMUNICATION_UNAVAILABLE_TEXT =
    'Kommunikation nicht möglich: Für diesen Termin fehlt die Behandler:in oder die Versicherungsart.';

export const COMMUNICATION_SAVE_FAILED_TEXT = 'Kommunikation konnte nicht gespeichert werden.';

/**
 * Reasons the endpoint can reject a save that the front desk can actually act on, keyed by status.
 * Anything else stays generic — the raw backend message is never shown.
 */
export const COMMUNICATION_ERROR_TEXT_BY_STATUS: Readonly<Record<number, string>> = {
    404: 'Dieser Patient existiert in DocCirrus nicht mehr, etwa nach einer Zusammenführung. Bitte den Eintrag direkt in DocCirrus erfassen.',
    422: 'Der Patient hat in DocCirrus keinen passenden Kostenträger für diese Versicherungsart. Bitte den Kostenträger in DocCirrus ergänzen.',
};
